import React from 'react'
import UnAuthorize from '../../components/UnAuthorize'

const UnAuthorized = () => <UnAuthorize/>

export default UnAuthorized
